import { getSessionStorage } from './storage/sessionStorage';

export function getInternalSessionId() {
  return getSessionStorage().getItem('internalId');
}

export function setInternalSessionId(id) {
  return getSessionStorage().setItem('internalId', id);
}
